import { Card, ChoiceList, FormLayout, Layout, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import HeadingHelper from "../../helpers/HeadingHelper";
import Switch from "react-switch/index";
import ChoiceHelper from "../../helpers/ChoiceHelper";
import React from "react";

const CompanyPayment = (props) => {
  const {
    paymentGatewaysActive, paymentGateways, paymentGatewayOthers,
    cardTypesActive, cardTypes,
    handleChange, handleChoiceListChange,
    voucherDiscount,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("company.annotate.title.payment")}
      description={CsI18n.t("company.annotate.desc.payment")}>
      <Card>
        <Card.Section>
          <FormLayout>
            {HeadingHelper.h3tt('Payment gateways', 'company.explain.payment_gateways')}
            <Switch
              className="react-switch"
              onChange={handleChange('paymentGatewaysActive')}
              checked={paymentGatewaysActive}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t('Payment gateways')}
            />
            {paymentGatewaysActive &&
            <FormLayout.Group>
              <div className="ChoiceList-Multiple">
                <ChoiceList
                  allowMultiple
                  title={HeadingHelper.l('Payment gateways')}
                  choices={ChoiceHelper.choices(paymentGateways)}
                  selected={ChoiceHelper.selected(paymentGateways)}
                  onChange={handleChoiceListChange("paymentGateways")}
                />
              </div>
              <TextField
                label={HeadingHelper.l('Other gateways')}
                onChange={handleChange("paymentGatewayOthers")}
                value={paymentGatewayOthers}
                placeholder={CsI18n.t("Ex: Ayden, Alipay, Verifone")}
                multiline
              />
            </FormLayout.Group>}
          </FormLayout>
        </Card.Section>

        <Card.Section>
          <FormLayout>
            {HeadingHelper.h3tt('Card types', 'company.explain.card_types')}
            <Switch
              className="react-switch"
              onChange={handleChange('cardTypesActive')}
              checked={cardTypesActive}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t("Card types")}
            />
            {cardTypesActive &&
            <ChoiceList
              title=""
              allowMultiple
              choices={ChoiceHelper.choices(cardTypes)}
              selected={ChoiceHelper.selected(cardTypes)}
              onChange={handleChoiceListChange("cardTypes")}
            />}
          </FormLayout>
        </Card.Section>

        <Card.Section>
          <FormLayout>
            {HeadingHelper.h3tt('Voucher/Discount', 'company.explain.voucher_discount')}
            <Switch
              className="react-switch"
              onChange={handleChange('voucherDiscount')}
              checked={voucherDiscount}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t("Voucher/Discount")}
            />
          </FormLayout>
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  )
}

export default CompanyPayment;